import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcoAlertInfo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0ZM13 4C13 3.44772 13.4477 3 14 3H17C17.5523 3 18 3.44772 18 4V7C18 7.55228 17.5523 8 17 8H14C13.4477 8 13 7.55228 13 7V4ZM18 11V10.5C18 9.94772 17.5523 9.5 17 9.5H11C10.4477 9.5 10 9.94772 10 10.5V13.5C10 14.0523 10.4477 14.5 11 14.5H13V21H10C9.44772 21 9 21.4477 9 22V25C9 25.5523 9.44771 26 10 26H20C20.5523 26 21 25.5523 21 25V22C21 21.4477 20.5523 21 20 21H18V13.5V11Z"
	})]
});
const ForwardRef = forwardRef(SvgIcoAlertInfo);
export { ForwardRef as ReactComponent };
